import React, { useEffect, useState } from 'react';
import axios from 'axios';
const API = window.location.origin + '/api';
const Admin = () => {
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const [dealers, setDealers] = useState<any[]>([]);
  const [matches, setMatches] = useState<any[]>([]);
  const [tab, setTab] = useState<'dealers'|'matches'>('dealers');
  useEffect(() => {
    axios.get(`${API}/admin/dealers`,{headers}).then(res=>setDealers(res.data.dealers||[]));
    axios.get(`${API}/admin/matches`,{headers}).then(res=>setMatches(res.data.matches||[]));
  }, []);
  const verify = async (id:number) => { await axios.post(`${API}/admin/dealers/${id}/verify`,{},{headers}); setDealers(prev=>prev.map(d=>d.id===id?{...d,verified:true}:d)); };
  const unverify = async (id:number) => { await axios.post(`${API}/admin/dealers/${id}/unverify`,{},{headers}); setDealers(prev=>prev.map(d=>d.id===id?{...d,verified:false}:d)); };
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Admin</h1>
      <div className="flex gap-2 mb-6">
        <button onClick={()=>setTab('dealers')} className={`px-4 py-2 rounded-lg text-sm font-medium ${tab==='dealers'?'bg-gray-900 text-white':'bg-white border border-gray-200 text-gray-600'}`}>Dealers ({dealers.length})</button>
        <button onClick={()=>setTab('matches')} className={`px-4 py-2 rounded-lg text-sm font-medium ${tab==='matches'?'bg-gray-900 text-white':'bg-white border border-gray-200 text-gray-600'}`}>Matches ({matches.length})</button>
      </div>
      {tab==='dealers'&&(
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200"><tr>{['ID','Company','Email','Country','Rating','Status','Actions'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500">{h}</th>)}</tr></thead>
            <tbody className="divide-y divide-gray-100">
              {dealers.map(d=>(
                <tr key={d.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-gray-400">{d.id}</td>
                  <td className="px-4 py-3 font-medium text-gray-900">{d.company_name}</td>
                  <td className="px-4 py-3 text-gray-500">{d.email}</td>
                  <td className="px-4 py-3 text-gray-500">{d.country}</td>
                  <td className="px-4 py-3 text-yellow-500">{d.rating&&d.rating_count>0?`★ ${parseFloat(d.rating).toFixed(1)} (${d.rating_count})`:'—'}</td>
                  <td className="px-4 py-3"><span className={`text-xs px-2 py-1 rounded-full font-medium ${d.verified?'bg-green-100 text-green-700':'bg-yellow-100 text-yellow-700'}`}>{d.verified?'VERIFIED':'PENDING'}</span></td>
                  <td className="px-4 py-3">{!d.verified?<button onClick={()=>verify(d.id)} className="text-xs px-3 py-1 rounded-lg text-white font-medium" style={{backgroundColor:'#B8860B'}}>Verify</button>:<button onClick={()=>unverify(d.id)} className="text-xs px-3 py-1 rounded-lg bg-gray-100 text-gray-600 font-medium">Unverify</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {tab==='matches'&&(
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200"><tr>{['ID','Dealer A','Dealer B','Status','Disputed'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500">{h}</th>)}</tr></thead>
            <tbody className="divide-y divide-gray-100">
              {matches.map(m=>(
                <tr key={m.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-gray-400">{m.id}</td>
                  <td className="px-4 py-3 font-medium">{m.name_a}</td>
                  <td className="px-4 py-3 font-medium">{m.name_b}</td>
                  <td className="px-4 py-3"><span className={`text-xs px-2 py-1 rounded-full font-medium ${m.status==='completed'?'bg-green-100 text-green-700':m.status==='disputed'?'bg-red-100 text-red-700':'bg-yellow-100 text-yellow-700'}`}>{m.status?.toUpperCase()}</span></td>
                  <td className="px-4 py-3">{m.disputed?<span className="text-red-500 text-xs">⚠️ {m.dispute_reason}</span>:'—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
export default Admin;
